/**
 * DescriptionBackgroundContainer component.
 */
import styled from 'styled-components';

/**
 * Styled detail background container.
 */
const DescriptionBackgroundContainer = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? 'visible' : 'none')};
  position: absolute;
  height: 100vh;
  width: 100vw;
`;

export default DescriptionBackgroundContainer;
